var React = require('react');

function UntitledDot (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Oval 2"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Desktop","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"Desktop-HD-Copy","transform":"translate(-973.000000, -419.000000)","fill":"#ACEEDF"},React.createElement("g",{"id":"Group-14-Copy","transform":"translate(874.000000, 270.000000)"},React.createElement("g",{"id":"Group-13","transform":"translate(20.535211, 137.000000)"},React.createElement("ellipse",{"id":"Oval-2","cx":"83.2816901","cy":"16","rx":"4.56338028","ry":"4"})))))]);
}

UntitledDot.defaultProps = {"width":"10px","height":"8px","viewBox":"0 0 10 8","version":"1.1"};

module.exports = UntitledDot;

UntitledDot.default = UntitledDot;
